import { connectRouter } from '../../router/RouterReduxBindings';
const loadRouterModule = (history) => ({
    id: 'Router',
    reducerMap: {
        router: connectRouter(history),
    },
});
export default loadRouterModule;
